/* eslint-disable */

export namespace $MTS {
  //invoke prefix
  const METAS_HEADER = 'metas:'; //调用标识
  const JS_INTERFACE = 'mtsImp';
  const GB = 'G'; //全局头部标识

  //platformid
  export const WEB = 0; //浏览器
  export const ANDROID = 1; //Android apk
  export const IOS = 2; //IOS
  export const WX = 3; //微信小游戏
  export const QQ = 4; //QQ小游戏

  //prop
  export const PROP_PLATFORM = 'sys.platform'; //当前运行环境(WEB\ANDROID\IOS)
  export const PROP_RELEASE = 'sys.prop.release';
  export const PROP_OS_VER = 'sys.prop.osVer';
  export const PROP_SHELL_VER = 'sys.prop.sVer';
  export const PROP_DEVICE_ID = 'sys.prop.did'; //设备UUID
  export const PROP_LOCAL_RUN = 'sys.prop.localWebRes'; //本地资源
  export const PROP_RAM = 'sys.prop.ram';
  export const PROP_ROM = 'sys.prop.rom';
  export const PROP_CPU_INFO = 'sys.prop.cpu';
  export const PROP_GPU_INFO = 'sys.prop.gpu';
  export const PROP_FACE = 'sys.prop.face';
  export const PROP_CMD_VIB = 'cmd.vibration';
  export const PROP_CMD_CLEARALL = 'cmd.clearAll'; //清楚所有
  export const PROP_CMD_CLEARDATA = 'cmd.clearData'; //清楚本地存储
  export const PROP_CMD_LOADING_PER = 'cmd.loading';
  export const PROP_CMD_PUSH_BTN = 'cmd.pushBtn'; //模拟拍击按钮事件
  //prop in url
  export const PROP_UID = 'uid'; //用户ID
  //invoke
  const PREFIX_CB = '_$CB$';

  const INVOKE_RESTART = 'restart';
  const INVOKE_EXIT = 'exit';
  const INVOKE_KEYBACK = 'onBack';
  const INVOKE_ON_PAUSE = 'onPause';
  const INVOKE_ON_RESUME = 'onResume';
  const INVOKE_ON_PAUSE_G = 'onPauseG';
  const INVOKE_ON_RESUME_G = 'onResumeG';
  const INVOKE_ON_READ_RFID = 'onReadRFID';
  const INVOKE_ON_READ_RACK = 'onReadRack';
  const INVOKE_ON_RACK_IN_WORKAREA = 'onRackInWorkArea'; //有衣架进入待加工区
  const INVOKE_ON_SCANNER_READ = 'onScannerRead'; //扫码枪事件
  const INVOKE_ON_PUSH_RACK = 'onPushRack'; //物理拍击按钮事件
  const INVOKE_ON_READ_MORE_EPC = 'onReadMoreEPC'; //医美读取RFID
  const INVOKE_LOG = 'log';
  const INVOKE_QR_SCAN = 'scanQRCode';
  const INVOKE_BARCODE_SCAN = 'scanBarCode';
  const INVOKE_GET_IMAGE = 'getImage';
  const INVOKE_PRINT = 'print';
  const INVOKE_ON_MSG = 'onCommonMsg';

  const BASE64KEY = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  const MAGIC_LOCAL_STORAGE = 'mts';
  const MAGIC_MESSAGE = 'mtsinframemessage';
  const CMD_DISPATCH_MSG = 'cmd_dispatchMsg'; //发送通用消息
  const CMD_CMD_CB = 'cmd_cb';
  const CMD_SET_ITEM = 'cmd_setItem';
  const CMD_GET_ITEM = 'cmd_getItem';
  export const URL_PARAM_SANDBOX = 'sandbox';
  const URL_PARAM_DID = 'did';
  const PREFIX_SUBVIEW_ID = 'sub_view';
  const ID_MAIN_VIEW = 'main_view';

  let _release: string;
  let _pid: number;

  let _pause: () => void;
  let _resume: () => void;
  let _comm: {
    comInit: (data: { id?: number; complete: (rsp?: any) => void }) => void;
    pause: (gid?: number) => void;
    resume: (gid?: number) => void;
    exit: () => void;
    prop: (name: string, val?: string | null, force?: boolean) => any;
    invoke: (type: string, funName: string, args: any[]) => void;
    postMsg: (dst: string, cb: (cbData: any) => void, data?: any) => void;
  };
  function pad(num: number, n: number): string {
    let len = num.toString().length;
    let numStr: string = '' + num;
    while (len < n) {
      numStr = '0' + numStr;
      len++;
    }
    return numStr;
  }

  function _logPrefix() {
    const date = new Date();
    return (
      '[' +
      pad(date.getHours(), 2) +
      ':' +
      pad(date.getMinutes(), 2) +
      ':' +
      pad(date.getSeconds(), 2) +
      '.' +
      pad(date.getMilliseconds(), 3) +
      ']'
    );
  }
  function _logSuffix(stacks: string[]) {
    if (stacks) {
      if (stacks.length > 3) {
        //'    at $function$ ($filepath$:$row$:$column$)' -> '    at $function$ ($row$:$column$)'
        const tip1 = stacks[3].substring(0, stacks[3].indexOf('(')).trim();
        const tip2 = stacks[3].substring(stacks[3].lastIndexOf('/'));
        return '|' + tip1 + tip2;
      }
    }
  }
  export function warn(...data: any[]) {
    if (_release == '1') return;
    switch (_pid) {
      case IOS:
      case ANDROID:
        if (window['conch']) {
          _comm.invoke(GB, INVOKE_LOG, data);
        } else {
          console.warn(data.join(','));
        }
        break;
      default:
        console.warn(_logPrefix(), data.join(','));
        break;
    }
  }
  export function log(...data: any[]) {
    if (_release == '1') return;
    switch (_pid) {
      case IOS:
      case ANDROID:
        if (window['conch']) {
          _comm.invoke(GB, INVOKE_LOG, data);
        } else {
          console.info(data.join(','));
        }
        break;
      default:
        console.info(_logPrefix(), data.join(','));
        break;
    }
  }
  export function assert(assert: any, log: string) {
    if (!assert && _release == '0') {
      throw new Error(log);
    }
  }
  function initPId(): number {
    try {
      if (window['mtsplatform']) {
        _pid = parseInt(window['mtsplatform']());
      } else if (window[JS_INTERFACE]) {
        _pid = ANDROID;
      } else if (window['wx']) {
        if (window['qq']) {
          _pid = QQ;
        } else {
          _pid = WX;
        }
      } else if (window['qq']) {
        _pid = QQ;
      } else {
        _pid = WEB;
      }
    } catch (error) {}
    //safe
    if (_pid === undefined) {
      _pid = WEB;
    }
    return _pid;
  }

  export function initcom(data: { id?: number; complete: (rsp?: any) => void }): void {
    switch (_pid) {
      case ANDROID:
        _comm = comAndr;
        break;
      default:
        _comm = comH5;
        break;
    }
    _comm.comInit(data);
  }

  export function saveToFile(filePath: string, href: string) {
    const aLink = document.createElement('a');
    aLink['download'] = filePath;
    aLink.href = href;
    const evt = document.createEvent('MouseEvents');
    evt.initMouseEvent(
      'click',
      true,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null,
    );
    aLink.dispatchEvent(evt);
  }

  function _utf8_decode(utftext: string): string {
    let string: string = '';
    let i: number = 0;
    let c: number, c1: number, c2: number, c3: number;
    while (i < utftext.length) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }
    }
    return string;
  }
  function _decode(input: string): string {
    let output: string = '';
    let chr1: number, chr2: number, chr3: number;
    let enc1: number, enc2: number, enc3: number, enc4: number;
    let i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
    while (i < input.length) {
      enc1 = BASE64KEY.indexOf(input.charAt(i++));
      enc2 = BASE64KEY.indexOf(input.charAt(i++));
      enc3 = BASE64KEY.indexOf(input.charAt(i++));
      enc4 = BASE64KEY.indexOf(input.charAt(i++));
      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;
      output = output + String.fromCharCode(chr1);
      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }
    output = _utf8_decode(output);
    return output;
  }

  function _loadURL(url: string): void {
    const iFrame = document.createElement('iframe');
    iFrame.setAttribute('src', url);
    iFrame.setAttribute('style', 'display:none;');
    iFrame.setAttribute('height', '0px');
    iFrame.setAttribute('width', '0px');
    iFrame.setAttribute('frameborder', '0');
    document.body.appendChild(iFrame);
    if (iFrame.parentNode) iFrame.parentNode.removeChild(iFrame);
  }

  function _genCBName(invokeName: string): string {
    return (PREFIX_CB + invokeName).replace('-', '');
  }
  function _clearCallbackForShell(name: string) {
    delete window[_genCBName(name)];
  }
  function _regCallbackForShell(
    name: string,
    callback: (rData?: any) => void,
    once: boolean = true,
  ): string {
    const fnName = _genCBName(name);
    window[fnName] = function (data: string) {
      if (_pid == IOS) {
        data = _decode(data);
      } else if (_pid == ANDROID && data && data.startsWith('$B64$')) {
        data = _decode(data.substr(5));
      }
      let logD: string = data;
      if (data && data.length > 256) logD = data.substr(0, 128) + '...';
      // log('js_call: ' + name + '(' + logD + ')');

      if (once) delete window[fnName];

      if (callback) {
        try {
          data ? callback(JSON.parse(data)) : callback();
        } catch (e: any) {
          // log('!!' + name + ' data:' + data + ' e:' + e.toString());
        }
      } else {
        // log('dummy:' + name);
      }
    };
    return fnName;
  }
  function _regCallback(
    name: string,
    callback: (data: string | number) => void,
    once: boolean = false,
  ): string {
    const fnName = _genCBName(name);
    window[fnName] = function (data: string | number) {
      if (callback) callback(data);
      else log('dummy:' + fnName);

      if (once) delete window[fnName];
    };
    return fnName;
  }
  function _invokeGlobalFN(fnName: string, params: string): any {
    if (window[fnName]) {
      return window[fnName](params);
    } else {
      return undefined;
    }
  }

  class comBase {
    private static _genSubViewId(suffix: string) {
      let ieId = PREFIX_SUBVIEW_ID;
      if (suffix !== undefined && suffix !== null) ieId = ieId + suffix;
      return ieId;
    }
    private static _regMessage() {
      window.addEventListener(
        'message',
        function (event) {
          if (event.data !== undefined) {
            comBase._onEngine(event.data);
          }
        },
        false,
      );
    }
    private static _postMsg(dst: string, data: any) {
      if (dst == App.id) {
        log('skip _postMsg [self:' + App.id + ']:' + JSON.stringify(data));
        const msg = MAGIC_MESSAGE + JSON.stringify(data);
        comH5._onEngine(msg);
      } else if (dst == ID_MAIN_VIEW) {
        const msg = MAGIC_MESSAGE + JSON.stringify(data);
        log('_postMsg [' + App.id + '-> 0(app)]:' + JSON.stringify(data));
        window.parent.postMessage(msg, '*');
      } else {
        const iframe = parent.document.getElementById(comBase._genSubViewId(dst));
        if (iframe) {
          log('_postMsg [' + App.id + '->' + dst + '(game)]:' + JSON.stringify(data));
          const msg = MAGIC_MESSAGE + JSON.stringify(data);
          iframe['contentWindow'].postMessage(msg, iframe['src']);
        } else {
          log('dummy iframe');
        }
      }
    }

    private static _onCmdCallbck(data: { cbn: string; cbData: any }) {
      if (data.cbn && window[data.cbn]) {
        const cb = window[data.cbn];
        delete window[data.cbn];
        cb(data.cbData);
      } else {
        log('!! _onCmdCallbck no callback:' + data.cbn);
      }
    }

    private static _onEngine(msg: string) {
      if (new RegExp(MAGIC_MESSAGE).test(msg)) {
        log('_recv msg:' + msg);
        const text = msg.slice(MAGIC_MESSAGE.length, msg.length);
        const data = JSON.parse(text);
        switch (data.cmd) {
          case CMD_SET_ITEM:
            comBase._cmdSetItem(data);
            break;
          case CMD_GET_ITEM:
            comBase._cmdGetItem(data);
            break;
          case CMD_DISPATCH_MSG:
            if (window[_genCBName(INVOKE_ON_MSG)]) {
              window[_genCBName(INVOKE_ON_MSG)](data);
            }
            break;
          case CMD_CMD_CB:
            comBase._onCmdCallbck(data);
            return;
          default:
            break;
        }
        if (data.cbn) {
          //src & dst 互换
          comBase._postMsg(data.src, {
            cmd: CMD_CMD_CB,
            src: App.id,
            cbn: data.cbn,
            cbData: data.cbData,
          });
        }
      }
    }
    private static _cmdSetItem(data: { key: string; val: string; del?: boolean }) {
      if (data.del) {
        MtsLocalStorage.removeItem(data.key);
      } else {
        MtsLocalStorage.setItem(data.key, data.val);
      }
    }
    private static _cmdGetItem(data: { key: string; cbData: any }) {
      data.cbData = MtsLocalStorage.getItem(data.key);
    }
    static prop(_name: string, _val?: string | null, _force?: boolean): any {
      return undefined;
    }
    static comInit(data: { complete: (rsp?: any) => void }): void {
      comBase._regMessage();
      if (data.complete) data.complete();
    }
    static pause(_gid?: number) {
      if (window[_genCBName(INVOKE_ON_PAUSE_G)]) {
        window[_genCBName(INVOKE_ON_PAUSE_G)]();
      } else {
        _pause();
      }
    }
    static resume(_gid?: number) {
      if (window[_genCBName(INVOKE_ON_RESUME_G)]) {
        window[_genCBName(INVOKE_ON_RESUME_G)]();
      } else {
        _resume();
      }
    }

    static exit() {
      _comm.invoke(GB, INVOKE_EXIT, []);
    }
    static _msgIdx: number = 1;
    static postMsg(dst: string, cb: (cbData: any) => void, cbData?: any) {
      const cbn = _genCBName(CMD_CMD_CB + '_' + this._msgIdx++);
      window[cbn] = function (data: any) {
        if (cb) cb(data);
        else log('dummy:' + cbn);

        delete window[cbn];
      };
      comBase._postMsg(dst, {
        cmd: CMD_DISPATCH_MSG,
        src: App.id,
        dst,
        cbn,
        cbData,
      });
    }
  }
  class comH5 extends comBase {
    private static _testDiv: HTMLElement;
    private static _testTitle: HTMLInputElement;
    private static _testOkBtn: HTMLElement;
    private static _testFailBtn: HTMLElement;
    private static _testCallback: string;

    private static _initTestElement() {
      comH5._testDiv = document.createElement('div');
      comH5._testDiv.style.cssText =
        'overflow-y:auto;z-index:1000000;background:rgba(0,0,0,0.2);color:black;position:absolute;';
      comH5._testDiv.style.left = '0px';
      comH5._testDiv.style.top = '0px';
      comH5._testDiv.style.right = '0px';
      comH5._testDiv.style.bottom = '0px';

      comH5._testTitle = document.createElement('input');
      comH5._testTitle.style.cssText = 'z-index:1000000;position: absolute;left:10px;top:10px;';
      comH5._testDiv.appendChild(comH5._testTitle);

      comH5._testOkBtn = document.createElement('button');
      comH5._testOkBtn.innerText = '扫码成功';
      comH5._testOkBtn.style.cssText = 'z-index:1000001;position: absolute;left:200px;top:50px;';
      comH5._testOkBtn.onclick = () => {
        _invokeGlobalFN(
          comH5._testCallback,
          JSON.stringify({ r: 0, data: comH5._testTitle.value }),
        );
        comH5._testDiv.style.display = 'none';
      };
      comH5._testDiv.appendChild(comH5._testOkBtn);

      comH5._testFailBtn = document.createElement('button');
      comH5._testFailBtn.innerText = '扫码失败';
      comH5._testFailBtn.style.cssText = 'z-index:1000001;position: absolute;left:200px;top:100px;';
      comH5._testFailBtn.onclick = () => {
        _invokeGlobalFN(comH5._testCallback, JSON.stringify({ r: -1, msg: '模拟失败' }));
        comH5._testDiv.style.display = 'none';
      };
      comH5._testDiv.appendChild(comH5._testFailBtn);
      comH5._testDiv.style.display = 'none';
      document.body.appendChild(comH5._testDiv);
    }

    private static _getKey(e: any) {
      e = e || window.event;
      const keycode = e.which ? e.which : e.keyCode;
      if (keycode == 27) {
        if (window[_genCBName(INVOKE_KEYBACK)]) window[_genCBName(INVOKE_KEYBACK)]();
      }
    }
    static override comInit(data: { id?: number; complete: (rsp?: any) => void }) {
      if (document.addEventListener) {
        document.addEventListener('keyup', comH5._getKey, false);
      } else if (document['attachEvent']) {
        document['attachEvent']('onkeyup', comH5._getKey);
      } else {
        document.onkeyup = comH5._getKey;
      }
      let val = MtsLocalStorage.getItem(PROP_DEVICE_ID);
      if (!val || val.length == 0) {
        val = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
        MtsLocalStorage.setItem(PROP_DEVICE_ID, val);
      }

      this._initTestElement();
      super.comInit(data);
    }
    static override prop(name: string, val?: string | null, force?: boolean) {
      const comVal = super.prop(name, val);
      if (comVal !== undefined) return comVal;

      if (name == PROP_CMD_CLEARALL || name == PROP_CMD_CLEARDATA) {
        MtsLocalStorage.clear();
        val = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
        MtsLocalStorage.setItem(PROP_DEVICE_ID, val);
        return;
      }

      if (val === undefined) {
        val = MtsLocalStorage.getItem(name);
        if (!val) {
          switch (name) {
            case PROP_RELEASE:
              return '0';
            case PROP_PLATFORM:
              return WEB;
            case PROP_OS_VER:
              return 'WEB_3.0';
            case PROP_SHELL_VER:
              return '1';
            case PROP_RAM:
              if (
                window.performance &&
                window.performance['memory'] &&
                window.performance['memory']['jsHeapSizeLimit']
              ) {
                return (
                  '' + Math.floor(window.performance['memory']['jsHeapSizeLimit'] / 1024 / 1024)
                );
              } else {
                return '4096';
              }
            case PROP_CPU_INFO:
            case PROP_GPU_INFO:
              return undefined;
            case 'sys.channel':
              return 'metas';

            default:
              if (name.startsWith('sys.prop.daload.')) return 'true';
              break;
          }
        }
        return val;
      } else {
        if (val === null || val === '') {
          MtsLocalStorage.removeItem(name);
        } else if (!name.startsWith('cmd.')) {
          MtsLocalStorage.setItem(name, val);
        }
      }
    }

    static invoke(type: string, funName: string, args: any[]): void {
      switch (funName) {
        case INVOKE_RESTART:
          if (args[2]) window.location.replace(args[2]);
          else window.location.reload();
          break;
        case INVOKE_EXIT:
          window.opener = null;
          window.close();
          break;
        case INVOKE_QR_SCAN:
          {
            comH5._testCallback = args[0];
            comH5._testDiv.style.display = '';
          }
          break;
        case INVOKE_BARCODE_SCAN:
          {
            comH5._testCallback = args[0];
            comH5._testDiv.style.display = '';
          }
          break;
        case INVOKE_GET_IMAGE:
          {
            alert('TODO: not support');
            // comH5._testDiv.style.display = "";
          }
          break;
        default:
          switch (type) {
            default:
              if (args && args[0]) {
                log('! not support:' + type + ' ' + funName + ' arg:' + JSON.stringify(args));
                _invokeGlobalFN(args[0], JSON.stringify({ r: 'fail', msg: 'not support!' }));
              }
              break;
          }
          break;
      }
    }
  }
  class comAndr extends comBase {
    static override prop(name: string, val?: string | null, force?: boolean): string | null {
      const comVal = super.prop(name, val);
      if (comVal !== undefined) return comVal;

      if (name == PROP_PLATFORM) return '' + ANDROID;
      if (val === undefined) {
        const data = window[JS_INTERFACE].getProperty(name);
        if (!data || data === '') return null;
        return data;
      } else if (val === null || val === '') {
        window[JS_INTERFACE].setProperty(name, '');
      } else {
        window[JS_INTERFACE].setProperty(name, val);
      }
      return null;
    }
    static invoke(type: string, funName: string, args: any[]) {
      const commend = {
        functionName: type + funName,
        arguments: args,
      };
      const jsonStr = JSON.stringify(commend);
      _loadURL(METAS_HEADER + jsonStr);
    }
  }

  class MtsLocalStorage {
    private static remapKey(k: string): string {
      if (App.getUrlParam(URL_PARAM_SANDBOX))
        return MAGIC_LOCAL_STORAGE + '##' + App.getUrlParam(URL_PARAM_SANDBOX) + '#' + k;
      else return k;
    }
    public static setItem(k: string, v: string): void {
      window.localStorage.setItem(this.remapKey(k), v);
    }
    public static getItem(k: string): string | null {
      if (k == PROP_DEVICE_ID && App.getUrlParam(URL_PARAM_DID)) {
        return App.getUrlParam(URL_PARAM_DID);
      }
      const v = window.localStorage.getItem(this.remapKey(k));
      if (v === null || v === undefined || (typeof v == 'string' && v.length == 0)) {
        return null;
      } else {
        return '' + v;
      }
    }
    public static removeItem(k: string): void {
      window.localStorage.removeItem(this.remapKey(k));
    }
    public static clear(): void {
      window.localStorage.clear();
    }
  }

  export class App {
    private static _inited: boolean = false;
    private static _id: string = ID_MAIN_VIEW;

    private static _initPId() {
      initPId();
      return _pid;
    }

    private static _requestParams = {};
    static getUrlParam(key: string) {
      return App._requestParams[key];
    }
    private static _initSearch() {
      const search = window.location.search;
      if (search && search.indexOf('?') != -1) {
        const str = search.substring(1);
        const strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
          const key = strs[i].split('=')[0];
          const val = strs[i].substring(key.length + 1);
          App._requestParams[key] = decodeURI(val);
        }
        if (App.getUrlParam(URL_PARAM_SANDBOX)) App._id = App.getUrlParam(URL_PARAM_SANDBOX);
      }
    }
    public static init(data: { complete: (rsp?: any) => void }): void {
      if (App._inited === true) {
        if (data.complete) data.complete();
        return;
      }

      App._initPId();
      App._initSearch(); //获取url中"?"符后的字串
      initcom({
        complete: (rsp) => {
          _release = _comm.prop(PROP_RELEASE);
          if (_release === null) _release = '1';

          _pause = () => {
            try {
              //TODO
              log('[Ga] com pause');
              window.blur();
            } catch (e) {
              log('[Ga] pause err:' + e);
            }
          };

          _resume = () => {
            try {
              //TODO
              log('[Ga] com resume');
              window.focus();
            } catch (e) {
              log('[Ga] resume err:' + e);
            }
          };

          log('[app] init');
          window[_genCBName(INVOKE_ON_PAUSE)] = function () {
            _comm.pause();
          };
          window[_genCBName(INVOKE_ON_RESUME)] = function () {
            _comm.resume();
          };

          // if (_pid == WEB) {
          //     let pauseBtn = document.createElement("button");
          //     pauseBtn.innerText = "暂停";
          //     pauseBtn.style.cssText = "z-index:1000001;position: absolute;right:5px;top:35px;";
          //     pauseBtn.onclick = () => {
          //         if (pauseBtn.innerText == '暂停') {
          //             pauseBtn.innerText = '恢复';
          //             window[_genCBName(INVOKE_ON_PAUSE)]();
          //         } else {
          //             pauseBtn.innerText = '暂停';
          //             window[_genCBName(INVOKE_ON_RESUME)]();
          //         }
          //     };
          //     document.body.appendChild(pauseBtn);
          // }

          App._inited = true;
          data.complete(rsp);
        },
      });
    }
    public static get id() {
      return App._id;
    }
    public static prop(name: string, val?: string, force?: boolean) {
      if (name == PROP_RELEASE && val !== undefined) _release = val;
      return _comm.prop(name, val, force);
    }
    public static startVib(times?: Number) {
      console.log(`_comm.prop(${PROP_CMD_VIB}, ${'' + times || '' + 20})`);
      return _comm.prop(PROP_CMD_VIB, '' + times || '' + 20); //强制改为20
    }

    public static pushBtn() {
      return _comm.prop(PROP_CMD_PUSH_BTN, ''); //模拟拍击按钮
    }

    public static onLoadingProgress(data: { loadCur: number; loadMax: number }) {
      _comm.prop(PROP_CMD_LOADING_PER, '' + Math.floor((data.loadCur * 100) / data.loadMax));
    }

    public static onPause(callback: () => void) {
      _regCallback(INVOKE_ON_PAUSE_G, callback);
    }
    public static onResume(callback: () => void) {
      _regCallback(INVOKE_ON_RESUME_G, callback);
    }

    public static restart(): void {
      _comm.invoke(GB, INVOKE_RESTART, [2]); //2代表重启自己
    }
    public static exit(): void {
      _comm.exit();
    }
    public static onKeyBack(callback: () => void) {
      /**注册KEY_BACK事件回调 */
      _regCallbackForShell(INVOKE_KEYBACK, callback, false);
    }

    public static onReadRFID(
      callback: (data: { cardId: number; deviceName: string; productName: string }) => void,
    ) {
      _regCallbackForShell(INVOKE_ON_READ_RFID, callback, false);
    }
    //模拟刷卡登录
    public static onSimulteSetRFID(data: string) {
      window[_genCBName(INVOKE_ON_READ_RFID)](data);
    }

    //模拟加工区事件
    public static onSimulteSetRackInWorkArea(data: string) {
      window[_genCBName(INVOKE_ON_RACK_IN_WORKAREA)](data);
    }

    //模拟扫码枪事件
    public static onSimulteSetScannerData(data: string) {
      window[_genCBName(INVOKE_ON_SCANNER_READ)](data);
    }

    // 医美读取RFID事件
    public static onReadMoreEPC(callback: (data: { epcList: string[] }) => void) {
      _regCallbackForShell(INVOKE_ON_READ_MORE_EPC, callback, false);
    }

    // 模拟触发医美读取RFID事件
    public static onSimulteSetReadMoreEpc(data: string) {
      window[_genCBName(INVOKE_ON_READ_MORE_EPC)](data);
    }

    //模拟拍击事件
    public static onSimultePushRackData() {
      window[_genCBName(INVOKE_ON_PUSH_RACK)]();
    }

    public static onReadRackID(
      callback: (data: { cardId: number; deviceName: string; productName: string }) => void,
    ) {
      _regCallbackForShell(INVOKE_ON_READ_RACK, callback, false);
    }

    public static onPushRack(callback: () => void) {
      _regCallbackForShell(INVOKE_ON_PUSH_RACK, callback, false);
    }

    public static onRackInWorkArea(callback: (data: { cardId: number }) => void) {
      _regCallbackForShell(INVOKE_ON_RACK_IN_WORKAREA, callback, false);
    }

    public static onScannerRead(callback: (data: { code: string; deviceName: string }) => void) {
      _regCallbackForShell(INVOKE_ON_SCANNER_READ, callback, false);
    }
    public static onMessage(callback: (data: any) => void) {
      _regCallback(INVOKE_ON_MSG, callback);
    }

    public static sendMessage(dst: string, cb: (cbData: any) => void, data?: any) {
      _comm.postMsg(dst, cb, data);
    }

    public static windowHeight(): number {
      return window.innerHeight;
    }

    public static windowWidth(): number {
      return window.innerWidth;
    }

    public static getQRCode(params: { cb: (data: { r: number; data: string }) => void }): void {
      _comm.invoke(GB, INVOKE_QR_SCAN, [_regCallbackForShell(INVOKE_QR_SCAN, params.cb, true)]);
    }

    public static startCamLogin(params: { cb: (data: { r: number; data: string }) => void }): void {
      _comm.invoke(GB, 'startCamLogin', [_regCallbackForShell('startCamLogin', params.cb, true)]);
    }

    public static stopCamLogin(): void {
      _comm.invoke(GB, 'stopCamLogin', []);
    }

    public static getBarCode(params: { cb: (data: { r: number; data: string }) => void }): void {
      _comm.invoke(GB, INVOKE_BARCODE_SCAN, [
        _regCallbackForShell(INVOKE_BARCODE_SCAN, params.cb, true),
      ]);
    }

    public static getImage(params: { cb: (data: { r: number; data: string }) => void }): void {
      _comm.invoke(GB, INVOKE_GET_IMAGE, [_regCallbackForShell(INVOKE_GET_IMAGE, params.cb, true)]);
    }

    public static print(params: {
      cb: (data: { r: number; data: string }) => void;
      data: string;
      dpi?: number;
    }) {
      _comm.invoke(GB, INVOKE_PRINT, [
        _regCallbackForShell(INVOKE_PRINT, params.cb, true),
        params.data,
        params.dpi,
      ]);
    }
    public static setItem(key: string, value: string) {
      MtsLocalStorage.setItem(key, value);
    }

    public static getItem(key: string, def?: string) {
      const val = MtsLocalStorage.getItem(key);
      if (def && val === null) {
        return def;
      }
      return val;
    }
    public static removeItem(key: string) {
      return MtsLocalStorage.removeItem(key);
    }
    public static clear() {
      return MtsLocalStorage.clear();
    }
  }

  //http ajax
  class FWXHR {
    private static _XOR_FB1_HEADER_LEN = 8;
    private static _FB1_SUFFLE = [
      0xac, 0xa7, 0x47, 0x5a, 0x38, 0x55, 0x69, 0xaa, 0x22, 0xaf, 0xf3, 0x5f, 0x81, 0x65, 0xed,
      0xf1,
    ];
    private static _stringToUtf8ByteArray(str: string): any[] {
      let out: number[] = [],
        p = 0;
      for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        if (c < 128) {
          out[p++] = c;
        } else if (c < 2048) {
          out[p++] = (c >> 6) | 192;
          out[p++] = (c & 63) | 128;
        } else if (
          (c & 0xfc00) == 0xd800 &&
          i + 1 < str.length &&
          (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00
        ) {
          // Surrogate Pair
          c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
          out[p++] = (c >> 18) | 240;
          out[p++] = ((c >> 12) & 63) | 128;
          out[p++] = ((c >> 6) & 63) | 128;
          out[p++] = (c & 63) | 128;
        } else {
          out[p++] = (c >> 12) | 224;
          out[p++] = ((c >> 6) & 63) | 128;
          out[p++] = (c & 63) | 128;
        }
      }
      return out;
    }
    private static _utf8ByteArrayToString(bytes: any[]): string {
      let out: string[] = [],
        pos = 0,
        c = 0;
      while (pos < bytes.length) {
        const c1 = bytes[pos++];
        if (c1 < 128) {
          out[c++] = String.fromCharCode(c1);
        } else if (c1 > 191 && c1 < 224) {
          const c2 = bytes[pos++];
          out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        } else if (c1 > 239 && c1 < 365) {
          // Surrogate Pair
          const c2 = bytes[pos++];
          const c3 = bytes[pos++];
          const c4 = bytes[pos++];
          const u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) - 0x10000;
          out[c++] = String.fromCharCode(0xd800 + (u >> 10));
          out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
          const c2 = bytes[pos++];
          const c3 = bytes[pos++];
          out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
      }
      return out.join('');
    }
    static encodeXorFB1(str: string): Uint8Array | ArrayBuffer {
      const input = this._stringToUtf8ByteArray(str);
      const len = input.length;
      const outArray = new ArrayBuffer(len + this._XOR_FB1_HEADER_LEN);
      const out: any = new Uint8Array(outArray);
      const key: number[] = [];
      for (let i = 0; i < this._XOR_FB1_HEADER_LEN; i++) {
        out[i] = (Math.random() * 256) | 0;
        key.push(((out[i] & 0xff) + len + (i * 3 + 2)) & 0xff);
      }
      const rot = (key[0] & 0xff) + (key[1] & 0xff);
      for (let i = 0; i < len; i++) {
        const kOff = i % this._XOR_FB1_HEADER_LEN;
        let k: number = key[kOff];
        k = (k ^ this._FB1_SUFFLE[i & 15]) & 0xff;
        k = ((k << 1) | ((k >> 7) & 1)) & 0xff;
        key[kOff] = k;
        const r = (rot + i + (this._FB1_SUFFLE[i & 15] & 0xff) + k) & 7;
        let b = ((input[i] & 0xff) ^ k) & 0xff;
        b = (b >> r) | (b << (8 - r));
        out[i + this._XOR_FB1_HEADER_LEN] = b;
      }
      if (_pid == IOS) return out;
      else return outArray;
    }
    static decodeXorFB1(input: any /*Uint8Array | ArrayBuffer*/) {
      if (input instanceof ArrayBuffer) input = new Uint8Array(input);
      const len = input.length - this._XOR_FB1_HEADER_LEN;
      const key: number[] = [];
      for (let i = 0; i < this._XOR_FB1_HEADER_LEN; i++) {
        key.push(((input[i] & 0xff) + len + (i * 3 + 2)) & 0xff);
      }
      const out: number[] = [];
      const rot = (key[0] & 0xff) + (key[1] & 0xff);
      for (let i = 0; i < len; i++) {
        const kOff = i % this._XOR_FB1_HEADER_LEN;
        let k = key[kOff];
        k = (k ^ this._FB1_SUFFLE[i & 15]) & 0xff;
        k = ((k << 1) | ((k >> 7) & 1)) & 0xff;
        key[kOff] = k;
        const r = (rot + i + (this._FB1_SUFFLE[i & 15] & 0xff) + k) & 7;
        let b = input[i + this._XOR_FB1_HEADER_LEN];
        b = ((b << r) | ((b & 0xff) >> (8 - r))) & 0xff;
        out.push((b ^ k) & 0xff);
      }
      return this._utf8ByteArrayToString(out);
    }

    static _createXHR(): XMLHttpRequest {
      return new XMLHttpRequest();
    }
    static _defaultAjaxSuccessHandler() {}
    static _defaultAjaxErrorHandler() {}
    static _defaultAjaxCompleteHandler() {}
    static _xhrJsonHandler(mx: FWXHR) {
      return JSON.parse(mx._xhr.responseText);
    }
    static _xhrJsonJFBHandler(mx: FWXHR) {
      return JSON.parse(this.decodeXorFB1(mx._xhr.response));
    }
    static _xhrXmlHandler(mx: FWXHR) {
      return mx._xhr.responseXML;
    }
    static _xhrHtmlHandler(mx: FWXHR) {
      return mx._xhr.responseText;
    }
    static _xhrJsonPHandler(mx: FWXHR) {}
    static _xhrTextHandler(mx: FWXHR) {
      return mx._xhr.responseText;
    }
    static _xhrNoneHandler(mx: FWXHR) {
      return null;
    }
    static _ajaxDataFilter(dat: any): any {
      return dat;
    }
    _xhr: any;
    url!: string;
    type: any;
    async: any;
    dataType: any;
    contentType: any;
    data: any;
    password: any;
    username: any;
    timeout: any;
    cache: any;
    accepts: any;
    headers: any;
    mimeType: any;
    status: number = 0;
    readyStatus: number = 0;
    success!: (data: any, msg: string, fwxhr: FWXHR) => void;
    error!: (fwxhr: FWXHR, msg: string, errMsg: string) => void;
    complete!: (fwxhr: FWXHR, msg: string) => void;
    ifModified: any;
    dataFilter: any;
    partial: any;
    resultHandler: any;
    resultData: any;
    private hasDone: boolean = false;
    start(): void {
      const t: FWXHR = this;
      const xhr = t._xhr;
      t.hasDone = false;
      if (t.username) xhr.open(t.type, t.url, t.async, t.username, t.password);
      else xhr.open(t.type, t.url, t.async);
      if (t.mimeType) xhr.overrideMimeType(t.mimeType);
      if (t.data && t.contentType) {
        xhr.setRequestHeader('Content-Type', t.contentType);
      }
      if (t.ifModified) {
        xhr.setRequestHeader('If-Modified-Since', t.ifModified);
      }
      if (t.dataType == 'xml') {
        xhr.responseType = 'document';
      } else if (t.dataType == 'jfb' || t.dataType == 'arraybuffer') {
        xhr.responseType = 'arraybuffer';
      }
      if (t.accepts && t.accepts.length > 0) {
        let acc = '';
        for (let ai = 0; ai < t.accepts.length; ai++) {
          if (ai > 0) acc += ', ';
          acc += t.accepts[ai];
        }
        xhr.setRequestHeader('Accept', acc);
      }
      if (t.headers) {
        for (const name in t.headers) {
          if (name !== undefined && t.headers.hasOwnProperty(name) && t.headers[name] !== undefined)
            xhr.setRequestHeader(name, t.headers[name]);
        }
      }
      let timer: any = undefined;
      if (t.timeout && t.timeout > 0) {
        timer = setTimeout(function () {
          clearTimeout(timer);
          t.hasDone = true;
          if (xhr && xhr.abort) xhr.abort();
          t.status = -99;
          t.error(t, 'timeout', '');
          t.complete(t, 'timeout');
        }, t.timeout);
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState) {
          t.readyStatus += Math.pow(10, xhr.readyState + 3); //readyState 0:UNSENT 1:OPENED 2:HEADERS_RECEIVED 3:LOADING 4:DONE
        }
        if (xhr.readyState == 4 && !t.hasDone) {
          t.hasDone = true;
          if (timer !== undefined) clearTimeout(timer);
          const statusStr = t._xhrMapHttpStatus(t._xhr);
          if (
            ((xhr.responseType == '' || xhr.responseType == 'text') && xhr.responseText == null) ||
            xhr.status == 0
          ) {
            t.status = t.readyStatus + 97;
            t.error(t, statusStr, '');
          } else {
            if (xhr.status == 200 || xhr.status == 206 || (t.ifModified && xhr.status == 304)) {
              t.status = xhr.status;
              try {
                if (xhr.status != 304) {
                  if (t.partial) t.partial(xhr.responseText, 'done');
                  t.resultData = t.resultHandler(t);
                }
                t.success(t.dataFilter(t.resultData, t), statusStr, t);
              } catch (e: any) {
                t.error(t, statusStr, e.toString());
              }
            } else {
              t.status = t.readyStatus + xhr.status;
              t.error(t, statusStr, xhr.statusText);
            }
          }
          t.complete(t, statusStr);
        } else if (xhr.readyState == 3 && t.partial) {
          t.partial(xhr.responseText, 'partial');
        }
      };
      try {
        if (t.data) xhr.send(t.data);
        else xhr.send();
      } catch (e: any) {
        t.hasDone = true;
        if (xhr.status == 0) {
          t.status = -95;
        }
        t.error(t, 'error', e.toString());
        t.complete(t, 'error');
      }
    }
    abort(): void {
      if (!this.hasDone && this._xhr && (this._xhr.readyState == 2 || this._xhr.readyState == 3)) {
        this.hasDone = true;
        if (this._xhr.abort) this._xhr.abort();
        this.status = -98;
        this.error(this, 'abort', '');
        this.complete(this, 'abort');
      }
    }
    done(cb: any): FWXHR {
      this.success = cb;
      return this;
    }
    fail(cb: any): FWXHR {
      this.error = cb;
      return this;
    }
    always(cb: any): FWXHR {
      this.complete = cb;
      return this;
    }

    private _xhrMapHttpStatus(xhr: XMLHttpRequest): string {
      if (
        ((xhr.responseType == '' || xhr.responseType == 'text') && xhr.responseText == null) ||
        xhr.status == 0
      ) {
        return 'error';
      } else {
        const s = xhr.status;
        if (s == 200 || s == 206) return 'success';
        else if (s == 304) return 'notmodified';
        else return 'error';
      }
    }
  }
  export class XMLHttp {
    private static _ajax(url: string, options: any): any {
      const mx = new FWXHR();
      mx.url = url;
      mx.type = options.type || 'GET';
      mx.async = options.async === undefined ? true : options.async;
      mx.dataType = options.dataType || 'html';
      mx.contentType = options.contentType || 'application/x-www-form-urlencoded; charset=UTF-8';
      mx.data = options.data;
      mx.password = options.password || undefined;
      mx.username = options.username || undefined;
      mx.timeout = options.timeout || undefined;
      mx.cache = options.cache || false;
      mx.accepts = options.accepts || [];
      mx.headers = options.headers || {};
      mx.mimeType = options.mimeType;
      mx.success = options.success || FWXHR._defaultAjaxSuccessHandler;
      mx.error = options.error || FWXHR._defaultAjaxErrorHandler;
      mx.complete = options.complete || FWXHR._defaultAjaxCompleteHandler;
      mx.ifModified = options.ifModified;
      mx.dataFilter = options.dataFilter || FWXHR._ajaxDataFilter;
      mx.partial = options.partial || undefined;
      if (options.resultHandler) {
        mx.resultHandler = options.resultHandler;
      } else {
        if (mx.dataType == 'html') mx.resultHandler = FWXHR._xhrHtmlHandler;
        else if (mx.dataType == 'xml') mx.resultHandler = FWXHR._xhrXmlHandler;
        else if (mx.dataType == 'json') mx.resultHandler = FWXHR._xhrJsonHandler;
        else if (mx.dataType == 'text') mx.resultHandler = FWXHR._xhrTextHandler;
        else if (mx.dataType == 'jfb') mx.resultHandler = FWXHR._xhrJsonJFBHandler;
      }
      mx.resultHandler = mx.resultHandler || FWXHR._xhrNoneHandler;

      mx._xhr = FWXHR._createXHR();
      if (options.start === undefined || options.start == true) mx.start();
      return mx;
    }

    static getJSON(
      url: string,
      complete?: (xhr: object /*FWXHR*/, rspData: any, usedTS: number) => void,
      timout?: number,
      headers?: any,
    ): any {
      const entryTS = Date.now();
      const options = {
        type: 'GET',
        async: true,
        success(data, status, fwxhr) {
          if (complete) complete(fwxhr, data, Date.now() - entryTS);
        },
        error(fwxhr, status, errMsg: string) {
          log('[http]!' + status + ':' + errMsg + ' ' + url);
          if (complete) complete(fwxhr, undefined, Date.now() - entryTS);
        },
        timeout: timout ? timout : 10000,
        headers: headers,
      };
      XMLHttp._ajax(url, options);
    }

    static postJSONEx(
      url: string,
      reqData: object,
      complete?: (xhr: any /*FWXHR*/, rspData: any, usedTS: number) => void,
      timout?: number,
      headers?: any,
    ): void {
      const entryTS = Date.now();
      const options = {
        type: 'POST',
        async: true,
        success(data: any, status: string, fwxhr: FWXHR) {
          if (complete) complete(fwxhr, data, Date.now() - entryTS);
        },
        error(fwxhr: FWXHR, status: string, errMsg: string) {
          log('[http]!' + status + ':' + errMsg + ' ' + url);
          if (complete) complete(fwxhr, undefined, Date.now() - entryTS);
        },
        timeout: timout ? timout : 15000,
        headers: headers,
      };
      const xor = true;
      const strData = JSON.stringify(reqData);
      if (xor) {
        options['data'] = FWXHR.encodeXorFB1(strData);
        options['dataType'] = 'jfb';
        options['accepts'] = ['application/vnd.mts-json'];
        options['contentType'] = 'application/vnd.mts-json';
      } else {
        options['data'] = strData;
        options['dataType'] = 'json';
        options['contentType'] = 'application/json; charset=UTF-8';
      }

      XMLHttp._ajax(url, options);
    }
  }
}
